import SimpleDataTable from "./SimpleDataTable";

export default SimpleDataTable;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/SimpleDataTable/index.tsx